import { i18next } from './i18next_init';
import { 
  loadLanguage,
  languageSelectorInteractions,
  scanHtml,
  scanHtmlAndTranslate,
  buildDataTranslation
} from './helpers';

var isNotBot = !/bot|googlebot|crawler|spider|robot|crawling|Chrome-Lighthouse/i.test(navigator.userAgent);

if(isNotBot && window.multilingual_settings) {
  let {
    indirectTranslations,
    currentLangIso,
    supportedLanguages,
    additionalSeparator
  } = window.multilingual_settings;

  let innerTextTranslations = indirectTranslations.filter(({
    cssSelector,
    translation,
    useInnerText,
    attr
  }) => useInnerText);

  let firstLoad = true;
  i18next.on('languageChanged', async (lang) => {
    if(firstLoad) {
      i18next.loadedLanguages = [];
      await scanHtml();
    }

    //this updates the cart attribute to know the language of the user when they checkout
    fetch(`/cart/update.js?attributes[Language]=${i18next.language}`);
    
    /**
     * when the page just loaded it falls in the else. On page load, we don't need to
     * translate all the html, but we still to load the languages texts
     * for things that can load later (ex: ajax cart)
     * 
     * On later languageChanged, we need to translate the html. 
     */
    if(!firstLoad || (firstLoad && i18next.language != currentLangIso)) {
      loadLanguage(i18next.language, true);
    }
    else {
      loadLanguage(i18next.language);
    }

    i18next.languageIndex = supportedLanguages.indexOf(i18next.language);
    
    firstLoad = false;
  });


  languageSelectorInteractions();

  if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
    multilingualMutationObserver();
  }
  else {
    document.addEventListener('DOMContentLoaded', function(){ 
      multilingualMutationObserver();
    });
  }
  
  function translate($element, indirectTranslation) {
    setTimeout(() => {
      let {
        cssSelector,
        translation,
        useInnerText,
        attr
      } = indirectTranslation;
  
      let options = {}
      if(useInnerText) {
        let innerText;
        if(attr) {
          innerText = $element.getAttribute(attr);
          options.attr = attr;
        }
        else {
          innerText = $element.innerHTML;
        }
  
        translation = innerText.replace("<p>||</p>", "||");
  
        if(additionalSeparator) {
          translation = translation.replace("<p>" + additionalSeparator + "</p>", additionalSeparator);
        }
      }
  
      $element.setAttribute('data-i18n', buildDataTranslation(translation, options));
      scanHtmlAndTranslate($element.parentElement);
    });
  }

  function checkIndirectTranslations(mutation) {
    if(mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((addedNode) => {
        indirectTranslations.forEach((indirectTranslation) => 
          setTimeout(() => {
            if(addedNode.parentElement && (addedNode.parentElement.querySelector(indirectTranslation.cssSelector) || addedNode.parentElement.matches(indirectTranslation.cssSelector))){
              const elementsToTranslate = Array.from(addedNode.parentElement.querySelectorAll(indirectTranslation.cssSelector));
  
              elementsToTranslate.forEach(($element) => {
                if(!$element.hasAttribute("data-i18n") && !$element.hasAttribute("data-i18n-key")) {
                  translate($element, indirectTranslation);
                }
              })
            }
          })
        );
      })
    } else if(mutation.type === "childList") {
      innerTextTranslations.forEach((indirectTranslation) => 
        setTimeout(() => {
          const elementsToTranslate = Array.from(mutation.target.querySelectorAll(indirectTranslation.cssSelector));
        
          elementsToTranslate.forEach(($element) => {
            translate($element, indirectTranslation);
          });
        })
      );
    }
  }

  function multilingualMutationObserver() {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        setTimeout(() => {          
          if (mutation.type === "attributes" && mutation.attributeName !== "id" && mutation.attributeName !== "style" && mutation.attributeName !== "data-i18n" && mutation.attributeName !== "data-old-translation") {
            if (mutation.target.hasAttribute('data-i18n')) {
              scanHtmlAndTranslate(mutation.target.parentElement);            
            }
          } else {
            if (mutation.target.querySelector('[data-i18n]')) {
              scanHtmlAndTranslate(mutation.target.parentElement);
            }
            
            checkIndirectTranslations(mutation);
          }
        });
      })
    });

    observer.observe(document.body, {
      childList: true,
      attributes: false,
      subtree: true
    });
  }
}
